import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Book } from 'src/app/models/Book.model';
import { BooksService } from 'src/app/services/books.service';

@Component({
  selector: 'app-single-book',
  templateUrl: './single-book.component.html',
  styleUrls: ['./single-book.component.scss']
})
export class SingleBookComponent implements OnInit {

  book!: Book;

  constructor(private route: ActivatedRoute,
              private booksService: BooksService,
              private router: Router) {}

  ngOnInit(): void {
    // On créé temporairement un book vide, car récupérer les informations du livre peut prendre du temps. Si on ne fait pas ça, ça va causer des bugs.

    this.book = new Book('', '');

    const id:number = this.route.snapshot.params['id'];
    // Ajouter le + à id pour cast en number
    
    this.booksService.getSingleBook(+id).then(
      (book: Book) => {
        this.book = book;
      }
    );
  }

  onBack() {
    this.router.navigate(['/books']);
  }

}
